// extracted by mini-css-extract-plugin
export default {"wrapper":"HotelGridview_wrapper__CBIZ7","heading":"HotelGridview_heading__L7n6x","grid":"HotelGridview_grid__fB6iJ","empty":"HotelGridview_empty__5VFXi"};